import { DecimalPipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormlyModule } from '@ngx-formly/core';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppInitService } from './core/services/system/app-init.service';
import { ManutencaoComponent } from './manutencao/manutencao.component';
import { PreparePortalComponent } from './prepare-portal.component';
import { FormFieldFormlyComponent } from './shared/form-field/components/formly/form-field-formly.component';
import { FormFieldModule } from './shared/form-field/form-field.module';
import { InputComponent } from './shared/input/components/input/input.component';
import { InputModule } from './shared/input/input.module';
import { RectSelectTypeComponent } from './shared/rect-select/components/rect-select-type/rect-select-type.component';
import { RectSelectModule } from './shared/rect-select/rect-select.module';
import { SelectComponent } from './shared/select/components/select/select.component';
import { SelectModule } from './shared/select/select.module';
import { WINDOW_PROVIDERS } from './shared/services/window-providers';

const maskConfig: Partial<IConfig> = {
  showTemplate: true,
  validation: true,
};

export function initializeTenantConfig(appInitService: AppInitService) {
  return (): Promise<void> => {
    return appInitService.init();
  };
}

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent, PreparePortalComponent, ManutencaoComponent],
  imports: [
    CoreModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    InputModule,
    FormFieldModule,
    SelectModule,
    RectSelectModule,
    MatDialogModule,
    MatButtonModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    NgxMaskModule.forRoot(maskConfig),
    FormlyModule.forRoot({
      types: [
        {
          name: 'input',
          component: InputComponent,
        },
        {
          name: 'select',
          component: SelectComponent,
        },
        {
          name: 'rect-select',
          component: RectSelectTypeComponent,
        },
      ],
      wrappers: [
        {
          name: 'form-field',
          component: FormFieldFormlyComponent,
        },
      ],
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt' },
    WINDOW_PROVIDERS,
    DecimalPipe,
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTenantConfig,
      deps: [AppInitService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
